// DV survey item (between stimuli). The fairness-perception question; the dv_submit
// event carries the value + time-to-first-response (spec §6).

import { INK } from "../style";

export function SurveyItem({ options, value, onPick }: { options: string[]; value: number | null; onPick: (v: number) => void }) {
  return (
    <section style={{ marginTop: 16, background: "#fbfbfa", border: "1px solid rgba(55,53,47,.1)", borderRadius: 6, padding: "18px 22px" }}>
      <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: ".06em", textTransform: "uppercase", color: "rgba(55,53,47,.4)", marginBottom: 8 }}>Survey item (between stimuli)</div>
      <div style={{ fontSize: 14.5, fontWeight: 600, color: INK, marginBottom: 12 }}>How fairly do you think this article covered what happened?</div>
      <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
        {options.map((label, i) => {
          const v = i + 1, on = value === v;
          return (
            <button key={v} onClick={() => onPick(v)}
              style={{ font: "inherit", fontSize: 12.5, fontWeight: on ? 600 : 500, padding: "8px 13px", borderRadius: 6, cursor: "pointer", border: "1px solid " + (on ? INK : "rgba(55,53,47,.16)"), background: on ? INK : "#fff", color: on ? "#fff" : "rgba(55,53,47,.65)" }}>
              {label}
            </button>
          );
        })}
      </div>
    </section>
  );
}
